import { compose } from 'recompose';

import SecondaryBarItemView from './SecondaryBarItemView';

export default compose()(SecondaryBarItemView);
